import { TSTitleCard } from '@/components/shared/card/Card';
import { useContracts } from '@/services/contract/useContracts';
import { FunctionComponent, useEffect, useState } from 'react';
import { FiFileText } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import adminStrings from '../admin.translations';
import AdminAddContractModal from './AdminAddContractModal';
import AdminContractTable from './AdminContractTable';
import { ColumnKey, COLUMNS_STORAGE_KEY, DEFAULT_VISIBLE, VALID_KEYS } from './AdminContractTable.config';
import AdminContractColumnSelector from './AdminContractColumnSelector';

const loadColumnsFromStorage = (): ColumnKey[] => {
  try {
    const raw = localStorage.getItem(COLUMNS_STORAGE_KEY);
    if (!raw) return DEFAULT_VISIBLE;
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return DEFAULT_VISIBLE;
    const valid = (parsed as string[]).filter((k): k is ColumnKey => VALID_KEYS.has(k as ColumnKey));
    return valid.length > 0 ? valid : DEFAULT_VISIBLE;
  } catch {
    return DEFAULT_VISIBLE;
  }
};

const AdminContractSection: FunctionComponent = () => {
  const [addContractModalOpen, setAddContractModalOpen] = useState(false);

  const navigate = useNavigate();

  const { contracts } = useContracts();

  const onContractEdit = (id: string) => {
    navigate(`${id}`);
  };

  const [visibleColumns, setVisibleColumns] = useState<ColumnKey[]>(loadColumnsFromStorage);

  useEffect(() => {
    localStorage.setItem(COLUMNS_STORAGE_KEY, JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  return (
    <>
      <TSTitleCard
        title={adminStrings.contractsSection.title}
        icon={FiFileText}
        className="w-full"
        primaryAction={{
          label: adminStrings.contractsSection.table.addNew,
          onClick: () => {
            setAddContractModalOpen(true);
          },
          icon: 'add'
        }}
        smallContent={<AdminContractColumnSelector visible={visibleColumns} onChange={setVisibleColumns} />}
      >
        <AdminContractTable contracts={contracts} onEdit={onContractEdit} visibleColumns={visibleColumns}  />
      </TSTitleCard>
      <AdminAddContractModal
        open={addContractModalOpen}
        onClose={() => {
          setAddContractModalOpen(false);
        }}
      />
    </>
  );
};

export default AdminContractSection;
